import { useClientPortalAPI } from "@certn/api";
import {
  BasicButton,
  ButtonGroup,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  List,
  ListItem,
  Modal,
  Text,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  title: string;
  clientId?: string;
  paymentProfileId: string;
  handleArchive: () => void;
  handleClose: () => void;
}

export function ArchivePaymentProfileModal(props: Props) {
  const { title, clientId, paymentProfileId, handleArchive, handleClose } =
    props;
  const { t } = useTranslation();

  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/customer-accounts/${clientId}/billing-profiles/`,
    {
      payment_profile: paymentProfileId,
    }
  );

  const isCardInUse = data?.results.length;
  const displayMessage = isCardInUse ? (
    <Trans>
      By clicking 'Archive', {{ title }} will be archived. The following billing
      profiles will be affected:
    </Trans>
  ) : (
    <Trans>By clicking 'Archive', {{ title }} will be archived.</Trans>
  );

  return (
    <Modal isOpen>
      <Dialog>
        {() => (
          <>
            <DialogHeader onClose={handleClose}>
              {t("Archive payment method")}
            </DialogHeader>
            <DialogContent>
              <Text style="form/body-primary" color="text-weak">
                {displayMessage}
              </Text>
              <div className={isCardInUse ? styles.list : undefined}>
                <List type="unordered">
                  {data?.results.map((profile) => (
                    <ListItem key={profile.id}>{profile.profile_name}</ListItem>
                  ))}
                </List>
              </div>
            </DialogContent>
            <DialogFooter>
              <ButtonGroup>
                <BasicButton
                  testID="cancel-archive-payment-profile-button"
                  size="medium"
                  onPress={handleClose}
                >
                  {t("Cancel")}
                </BasicButton>
                <DangerButton
                  testID="confirm-archive-payment-profile-button"
                  size="medium"
                  onPress={handleArchive}
                >
                  {t("Archive")}
                </DangerButton>
              </ButtonGroup>
            </DialogFooter>
          </>
        )}
      </Dialog>
    </Modal>
  );
}

const styles = {
  list: css({
    marginTop: "var(--space-4)",
  }),
};
